
const axiosConfig = {
    baseUrl: "https://miyun.sqjydjt.com/baize_miyun_management_system/",
    // baseUrl: "http://localhost/",
    // http://182.92.5.220/baize_miyun_management_system/
    timeout: 10000
}
export {
    axiosConfig
}



// WEBPACK FOOTER //
// ./src/config/config.js